export const blogListing = (nextPage, shown, total) => ({
    nextPage,
    shown,
    total,
    loading: false,
    error: false,

    get progress() {
        return this.total ? Math.min(100, this.shown / this.total * 100) : 100;
    },

    get countLabel() {
        const format = new Intl.NumberFormat('fa-IR');

        return `${format.format(this.shown)} از ${format.format(this.total)} مقاله`;
    },

    async loadMore() {
        if (this.loading || !this.nextPage) {
            return;
        }

        this.loading = true;
        this.error = false;

        try {
            const response = await fetch(this.nextPage, {
                headers: { Accept: 'text/html' },
            });

            if (!response.ok) {
                throw new Error('Unable to load articles.');
            }

            const page = new DOMParser().parseFromString(await response.text(), 'text/html');
            const grid = page.querySelector('[data-blog-posts]');

            if (!grid) {
                throw new Error('The article list is missing.');
            }

            const cards = [...grid.children];
            const firstLink = cards[0]?.querySelector('a');

            cards.forEach((card, index) => {
                card.style.setProperty('--landing-intro-delay', `${Math.min(index, 5) * 60}ms`);
            });

            this.$refs.posts.append(...cards);
            this.shown += cards.length;
            this.nextPage = grid.dataset.nextPage || null;

            if (firstLink) {
                firstLink.focus({ preventScroll: true });
            }
        } catch {
            this.error = true;
        } finally {
            this.loading = false;
        }
    },
});
